// assets/product-customiser.js
// Handles swatch selection, updates labels, recalculates display price.

(function () {
  const formatINR = (n) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(n);

  document.querySelectorAll('[data-pc]').forEach(initCustomiser);

  function initCustomiser(root) {
    const basePrice = parseFloat(root.dataset.basePrice) || 0;
    const groups = root.querySelectorAll('[data-pc-group]');

    const recalc = () => {
      let delta = 0;
      root.querySelectorAll('[data-pc-swatch].is-selected').forEach((sw) => {
        delta += parseFloat(sw.dataset.priceDelta) || 0;
      });
      const total = basePrice + delta;

      // Update any theme-side price display that opts in with [data-pc-total]
      document.querySelectorAll('[data-pc-total]').forEach((el) => {
        el.textContent = formatINR(total);
      });

      // Fire a custom event so the theme can sync its own price UI if needed
      root.dispatchEvent(
        new CustomEvent('pc:change', {
          detail: { total, delta, basePrice },
          bubbles: true,
        })
      );
    };

    groups.forEach((group) => {
      const swatches = group.querySelectorAll('[data-pc-swatch]');
      const labelEl = group.querySelector('[data-pc-selected]');

      swatches.forEach((sw) => {
        sw.addEventListener('click', (e) => {
          // Prevent the click triggering twice (label + radio)
          if (e.target.tagName === 'INPUT') return;
          e.preventDefault();
          selectSwatch(sw, swatches, labelEl);
          recalc();
        });

        // Keyboard support
        sw.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectSwatch(sw, swatches, labelEl);
            recalc();
          }
        });
        sw.setAttribute('tabindex', '0');
        sw.setAttribute('role', 'radio');
      });
    });

    // Initial recalc in case defaults include non-zero deltas
    recalc();
  }

  function selectSwatch(selected, all, labelEl) {
    all.forEach((s) => {
      s.classList.remove('is-selected');
      const r = s.querySelector('input[type="radio"]');
      if (r) r.checked = false;
      s.setAttribute('aria-checked', 'false');
    });
    selected.classList.add('is-selected');
    selected.setAttribute('aria-checked', 'true');
    const radio = selected.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (labelEl) labelEl.textContent = selected.dataset.name;
  }
})();
